enum AffectedElementType {
  CONTRACT = 'AppBundle\\Entity\\Contract',
  SIMULATION = 'AppBundle\\Entity\\Simulation',
}

export default AffectedElementType
